import {
    Box,
    FormControl,
    InputLabel,
    MenuItem,
    Select,
    Typography
} from "@mui/material";
import Paginate from "components/Paginate";
import Board from "./Board";

import useComments from "./useComments";

const Comments = () => {

    const {
        comments = [],
        lessons = [],
        page,
        maxPage,
        setPage = () => {},
        acceptedFilter,
        setAcceptedFilter = () => {},
        lessonFilter,
        setLessonFilter = () => {},
        refetch = () => {}
    } = useComments();

    return (
        <>
        <h5 className="title">Comentários</h5>
            <p className="text-muted" >Aqui são listados todos os comentários deste curso</p>
            <Box display="flex" gap={2} flexWrap="wrap" mb={2}>
                <FormControl size="small" sx={{ minWidth: 180 }}>
                    <InputLabel>Status</InputLabel>
                    <Select
                        label="Status"
                        value={acceptedFilter}
                        onChange={(event) => setAcceptedFilter(event.target.value)}
                    >
                        <MenuItem value="false">Pendentes</MenuItem>
                        <MenuItem value="true">Aprovados</MenuItem>
                        <MenuItem value="all">Todos</MenuItem>
                    </Select>
                </FormControl>
                <FormControl size="small" sx={{ minWidth: 240 }}>
                    <InputLabel>Aula</InputLabel>
                    <Select
                        label="Aula"
                        value={lessonFilter}
                        onChange={(event) => setLessonFilter(event.target.value)}
                    >
                        <MenuItem value="all">Todas as aulas</MenuItem>
                        {lessons?.map((lesson) => (
                            <MenuItem key={lesson?.id} value={lesson?.id}>
                                {lesson?.title}
                            </MenuItem>
                        ))}
                    </Select>
                </FormControl>
            </Box>
        <Box
            className="table-responsive"
        >
            <table
                className="table table-striped"
            >
                <thead>
                    <tr>
                        <th>Aula</th>
                        <th>Arquivo</th>
                        <th>Autor</th>
                        <th>Comentário</th>
                        <th>Status</th>
                        <th>Ações</th>
                    </tr>
                </thead>
                <tbody>
                    {comments?.map((comment, commentKey) => (
                        <Board
                            key={comment?.id || commentKey}
                            onUpdate={refetch}
                            {...comment}
                        />
                    ))}
                </tbody>
            </table>
            {comments?.length === 0 && (
            <Typography
                align={"center"}
            >
                Nenhum registro de comentário
            </Typography>
        )}
            <Paginate
                value={page}
                onChange={setPage}
                maxPage={maxPage}
            />
        </Box>
        </>
    );
}

export default Comments;
